export const SYSTEM_USER = {
  ID: "1a5bca92-b070-472c-b703-5e2b374f4484",
  EMAIL: "infra@rastrin.com"
};

/**
 * Sentinel a tracker puts in a `content` field it could NOT read (from "sem sinal"): the field is
 * unavailable, it is not a measurement and it is not zero. See `docs/data/normalized-fields.md`.
 * Always discard it before parsing or displaying a payload value.
 */
export const TRACKER_NO_SIGNAL = "S/N";
